import React from "react";
import { PhotoSeries } from "model/photo_series/PhotoSeries";
import SearchResultList from "components/common/SearchResultList";
import styled from "styled-components";
import PhotoSeriesLiEl from "./PhotoSeriesLiEl";

type Props = {
  seriesLi: PhotoSeries[];
};

const PhotoSeriesContent = ({ seriesLi }: Props) => {
  if (seriesLi.length === 0) {
    return <></>;
  }

  return (
    <Div>
      <SearchResultList<PhotoSeries>
        renderSingle={(photoSeries: PhotoSeries, ind: number) => (
          <PhotoSeriesLiEl
            photoSeries={photoSeries}
            key={`photo_series_${ind + 1}`}
          />
        )}
        results={seriesLi}
      />
    </Div>
  );
};

const Div = styled.div`
  margin-top: 0rem;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-auto-rows: auto;
  row-gap: 1rem;
  column-gap: 1rem;
  align-items: center;
`;

export default PhotoSeriesContent;
